export default __webpack_public_path__ + "static/icon-tile-size-dark-fa16d21f2e551082cff2a318f80dd877.png";